module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fmFSw"))).then(() => parcelRequire('d0iPb'));